// Third-party Imports
import { configureStore } from '@reduxjs/toolkit'

// Slice Imports
import sampleReducer from '@/redux-store/slices/sample'
import authReducer from '@/redux-store/slices/authReducer'
import bookReducer from '@/redux-store/slices/bookStore'
import blankPageReducer from '@/redux-store/slices/blankPageReducer'
import bookListReducer from '@/redux-store/slices/bookListStore'
export const store = configureStore({
  reducer: {
    sampleReducer,
    authReducer,
    bookReducer,
    blankPageReducer,
    bookListReducer
  },
  middleware: getDefaultMiddleware => getDefaultMiddleware({ serializableCheck: false })
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
